<template>
  <div id="custCardSetUser">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>客户定制月卡设置</el-breadcrumb-item>
          <el-breadcrumb-item>客户月卡分组设置</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="changeCust"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月卡分组::">
          <el-select v-model="selfGroupIDQuery"
                     placeholder="请选择分组"
                     clearable
                     filterable>
            <el-option v-for="item in choiceGroups"
                       :key="item.fGroupID"
                       :label="item.fGroupName"
                       :value="item.fGroupID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字::">
          <el-input placeholder="请输入用户编号/场库名称"
                    v-model="searchKeyWord"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="cardQuery">查询</el-button>
        </el-form-item>
        <el-form-item style="float:right;margin-right:0px;">
          <el-button type="primary"
                     size="small"
                     @click="addSyncCustCardSetUser"
                     v-if="is_edit">新增</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="cardList"
                border
                v-loading="loading"
                highlight-current-row
                style="width: 100%"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                          width="50"
                          label="序号"
                          :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fUsrNo"
                          label="用户编号">
        </el-table-column>
        <el-table-column prop="fCustNo"
                          label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName"
                          label="客户名称">
        </el-table-column>
        <el-table-column prop="fCardGrpName"
                          label="月卡分组名称">
        </el-table-column>
        <el-table-column prop="fParkName"
                          label="场库名称">
        </el-table-column>
        <el-table-column fixed="right"
                          align="left"
                          label="操作"
                          width="235">
          <template slot-scope="scope">
            <el-button @click="viewCard(scope.row)"
                        type="success"
                        size="mini">查看</el-button>
            <el-button size="mini"
                        type="warning"
                        @click="editCustCardSetUserForm(scope.$index, scope.row)"
                        v-if="is_edit">编辑</el-button>
            <el-button size="mini"
                        type="danger"
                        @click="deleteCustCardSetUserClient(scope.$index, scope.row)"
                        v-if="is_del">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="userGroupEdit">
      <el-dialog :title="custCardSetUser.operateFlag"
                  v-dialogDrag
                  :visible.sync="dialogGroupFormVisible"
                  top="20vh"
                  left="0vh"
                  width="30%">
        <el-form :model="custCardSetUser"
                  :rules="groupRules"
                  ref="custCardSetUserForm"
                  label-width="150px">
          <el-row style="padding-top:10px">
            <el-col :span="16">
              <el-form-item label="用户编号::"  prop="fUsrNo">
                <el-input
                    placeholder="请输入用户编号"
                    v-model="custCardSetUser.fUsrNo"
                    :disabled="!groupIsEdit"
                    class="input-with-select">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="客户名称::" prop="fCustID">
                <el-select v-model="custCardSetUser.fCustID"
                           filterable
                           placeholder="请选择客户"
                           :disabled="!groupIsEdit"
                           @change="changeRowCust"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="月卡分组::" prop="fCardGrpID">
                <el-select v-model="custCardSetUser.fCardGrpID"
                          placeholder="请选择分组"
                          :disabled="!groupIsEdit"
                          clearable
                          filterable>
                  <el-option v-for="item in choiceGroups"
                            :key="item.fGroupID"
                            :label="item.fGroupName"
                            :value="item.fGroupID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="场库名称::" prop="fParkID">
                <el-select v-model="custCardSetUser.fParkID"
                          clearable
                          filterable
                          :disabled="!groupIsEdit"
                          class="myCardInput">
                  <el-option v-for="item in choiceParks"
                            :key="item.fParkID"
                            :label="item.fParkName"
                            :value="item.fParkID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
              class="dialog-footer">
          <el-button type="primary"
                    :loading="save_loading"
                      @click="submitForm('custCardSetUserForm')"
                      v-if="groupIsEdit">{{save_msg}}</el-button>
          <el-button @click="dialogGroupFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <carInfoView ref="child"
                 reportActiveName="cardList"
                 :type="2"></carInfoView>
  </div>
</template>
<script>
import carInfoView from '../../components/carInfoView'
import { mapActions } from 'vuex'
import * as park from '../../api/park'
export default {
  components: { carInfoView },
  name: 'custCardSetUser',
  data () {
    return {
      save_loading: false,
      save_msg: '保存',
      save_msgs: '保存',
      is_edit: false,
      is_del: false,
      loading: false,
      searchKeyWord: '',
      effectiveVehicle: false,
      tableHeight: 0,
      tableDetailHeight: 0,
      choiceParks: [],
      selfParkID: '',
      choiceCusts: [],
      offlineCusts: [],
      choiceGroups: [],
      cardList: [],
      selCustID: '',
      fGrpID: '',
      selfGroupID: '',
      selfGroupIDQuery: '',
      pageSize: 20,
      pageNo: 1,
      total: 0,
      custCardSetUser: {
        fBigRowID: 0,
        edit: false,
        fUsrNo: '',
        operateFlag: '',
        fCustID: '',
        fCustNo: '',
        fCardGrpID: '',
        fCardGrpName: '',
        fParkID: '',
        fParkName: ''
      },
      groupRules: {
        fUsrNo: [
          { required: true, message: '请输入用户编号', trigger: 'change' }
        ],
        fCustID: [
          { required: true, message: '请输选择客户', trigger: 'change' }
        ],
        fCardGrpID: [
          { required: true, message: '请输选择月卡分组', trigger: 'change' }
        ],
        fParkID: [
          { required: true, message: '请输选场库', trigger: 'change' }
        ]
      },
      groupIsEdit: false,
      groupIsEdits: false,
      dialogGroupFormVisible: false
    }
  },
  methods: {
    ...mapActions([
      'getCardGroupByCustId', 'getCustByGroup', 'getCustCardSetUserListAsync', 'saveCustCardSetUser', 'deleteCustCardSetUser', 'getCurrentUserPers'
    ]),
    cardQuery () {
      this.initData()
      // let obj = {}
      // obj = this.choiceCusts.find((item) => {
      //   return item.fCustID === this.selCustID
      // })
      // this.custName = obj.unionName
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save_loading = true
          this.save_msg = '保存中…'
          if (this.custCardSetUser.fBigRowID > 0) {
            this.custCardSetUser.edit = true
          } else {
            this.custCardSetUser.edit = false
          }
          this.saveCustCardSetUser(this.custCardSetUser).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogGroupFormVisible = false
                this.initData()
                this.$message.success('数据保存成功')
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    addSyncCustCardSetUser () {
      setTimeout(() => {
        if (this.$refs['custCardSetUserForm']) {
          this.$refs['custCardSetUserForm'].clearValidate()
        }
      }, 50)
      this.groupIsEdit = true
      this.groupIsEdits = true
      this.custCardSetUser = {
        edit: false,
        operateFlag: '新增',
        fBigRowID: 0,
        fUsrNo: '',
        fCustID: '',
        fCustNo: '',
        fCardGrpID: '',
        fCardGrpName: '',
        fParkID: '',
        fParkName: ''
      }
      this.dialogGroupFormVisible = true
    },
    setPark (val) {
      this.choiceParks = []
      this.selfParkID = ''
      park.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let tmpParks = []
              Object.assign(tmpParks, data.Data)
              this.choiceParks = tmpParks
              if (this.choiceParks && this.choiceParks.length > 0) {
                // this.choiceParks.splice(0, 0, { fParkID: '0', fParkName: '全部' })
                this.selfParkID = this.choiceParks[0].fParkID
              }
            }
          }
        }
      })
    },
    changeRowCust (fCustID) {
      this.selfGroupID = ''
      this.choiceGroups = []
      this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let tmpGroups = []
            Object.assign(tmpGroups, data.Data)
            this.choiceGroups = tmpGroups
          }
        }
      })
      this.setPark(fCustID)
    },
    editCustCardSetUserForm (index, row) {
      setTimeout(() => {
        if (this.$refs['custCardSetUserForm']) {
          this.$refs['custCardSetUserForm'].clearValidate()
        }
      }, 50)
      this.custCardSetUser = {}
      this.custCardSetUser = row
      this.custCardSetUser.edit = true
      this.groupIsEdit = true
      this.groupIsEdits = false
      this.custCardSetUser.operateFlag = '编辑'
      this.custCardSetUser = {
        edit: false,
        operateFlag: '新增',
        fBigRowID: 0,
        fUsrNo: '',
        fCustID: '',
        fCustNo: '',
        fCardGrpID: '',
        fCardGrpName: '',
        fParkID: '',
        fParkName: ''
      }
      this.changeRowCust(row.fCustID)
      this.custCardSetUser = row
      this.dialogGroupFormVisible = true
    },
    viewCard (row) {
      setTimeout(() => {
        if (this.$refs['custCardSetUserForm']) {
          this.$refs['custCardSetUserForm'].clearValidate()
        }
      }, 50)
      this.custCardSetUser = {}
      this.custCardSetUser = row
      this.groupIsEdit = false
      this.groupIsEdits = false
      this.custCardSetUser.operateFlag = '查看'
      this.custCardSetUser = {
        edit: false,
        operateFlag: '新增',
        fBigRowID: 0,
        fUsrNo: '',
        fCustID: '',
        fCustNo: '',
        fCardGrpID: '',
        fCardGrpName: '',
        fParkID: '',
        fParkName: ''
      }
      this.changeRowCust(row.fCustID)
      this.custCardSetUser = row
      this.dialogGroupFormVisible = true
    },
    deleteCustCardSetUserClient (index, row) {
      this.$confirm('删除此记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteCustCardSetUser({ fBigRowID: row.fBigRowID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message.success('数据删除成功')
              this.initData()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    setDetailTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 560
      obj.tableDetailHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    initData () {
      this.cardList = []
      this.loading = true
      this.getCustCardSetUserListAsync({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupIDQuery,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        searchKeyWord: this.searchKeyWord,
        effectiveVehicle: this.effectiveVehicle,
        cardActiveName: this.cardActiveName,
        exportData: 0
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              this.cardList = data.Data.rows
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    changeCust (fCustID) {
      this.selfGroupIDQuery = ''
      this.choiceGroups = []
      this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let tmpGroups = []
            Object.assign(tmpGroups, data.Data)
            this.choiceGroups = tmpGroups
          }
        }
      })
    }
  },

  watch: {

  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 1039200 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
      this.setDetailTableHeight(sizethis)
    }
    this.getCustByGroup().then(res => {
      if (res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.fGrpID = this.choiceCusts[0].fGrpID
              this.changeCust(this.selCustID)
            }
            this.offlineCusts = custs.filter(r => r.fCustTypeID === '0') // 封闭式客户
          }
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
    this.setDetailTableHeight(this)
  }
}
</script>

<style>
#custCardSetUser .is-disabled .el-input__inner,
#custCardSetUser .is-disabled .el-textarea__inner {
  color: #606266;
}
#custCardSetUser .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#custCardSetUser .el-dialog__title {
  color: white;
}
#custCardSetUser .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#custCardSetUser .el-dialog__body {
  padding: 5px;
}
#custCardSetUser .warning-row {
  color: chocolate;
}
#custCardSetUser .error-row {
  color: #fb4545;
}
</style>
<style scoped>
.myCardLableClass .isRed {
  color: #fb4545;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.curRowInfo {
  margin-top: 10px;
}
.curRowInfo .el-row {
  margin-top: 10px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.el-upload__tip {
  margin-top: 0px;
  color: red;
}
.userGroupEdit .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.userGroupEdit .el-dialog__title {
  color: white;
}
.userGroupEdit .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.userGroupEdit .el-dialog__body {
  padding-top: 20px;
  padding-left: 20px;
  padding-left: 20px;
  padding-bottom: 0px;
}
#custCardSetUser .userGroupEdit .el-tabs__content {
  height: 400px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/cust/custCardSetUser.vue